var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('line-chart', { attrs: { "customOptions": _vm.customOptions, "loading": _vm.loading } }, [_c('el-checkbox-group', { model: { value: _vm.selectedChannels, callback: function callback($$v) {
        _vm.selectedChannels = $$v;
      }, expression: "selectedChannels" } }, _vm._l(_vm.channels, function (item, index) {
    return _c('el-checkbox', { key: index, attrs: { "label": item } });
  }), 1)], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };